var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-input-search",
        {
          attrs: {
            placeholder:
              _vm.language["column.pleaseChoose"] +
              _vm.language["common.agentButton"] +
              _vm.language["system.user.name"],
            readOnly: "",
            unselectable: "on",
            disabled: _vm.disabled
          },
          on: { search: _vm.onSearchDepUser },
          model: {
            value: _vm.textVals,
            callback: function($$v) {
              _vm.textVals = $$v
            },
            expression: "textVals"
          }
        },
        [
          _c(
            "a-button",
            {
              attrs: { slot: "enterButton", disabled: _vm.disabled },
              slot: "enterButton"
            },
            [
              _vm._v(
                _vm._s(
                  _vm.language["column.pleaseChoose"] + _vm.language["user"]
                )
              )
            ]
          )
        ],
        1
      ),
      _c("j-select-user-by-dep-modal", {
        ref: "selectModal",
        attrs: {
          "modal-width": _vm.modalWidth,
          multi: _vm.multi,
          "user-ids": _vm.value,
          store: _vm.storeField,
          text: _vm.textField
        },
        on: { ok: _vm.selectOK, initComp: _vm.initComp }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }